export class PlayerContent{
    playerContentID: number;
    contentID: number;
    playerID: number;
    lastModified: number;
    isVerified: number;
    startDate: number;
    endDate: number;
    interactionID: number;

    constructor(playerContentID?: number, contentID?: number, playerID?: number, lastModified?: number, isVerified?: number, startDate?: number, endDate?: number, interactionID?: number){
        this.playerContentID = playerContentID;
        this.contentID = contentID;
        this.playerID = playerID;
        this.lastModified = lastModified;
        this.isVerified = isVerified;
        this.startDate = startDate;
        this.endDate = endDate;
        this.interactionID = interactionID;
    }

    getContentID(): number{
        return this.contentID;
    }
    getPlayerID(): number{
        return this.playerID;
    }
    getLastModified(): number{
        return this.lastModified;
    }
    getStartDate(): number{
        return this.startDate;
    }
    setStartDate(sd: number): void{
        this.startDate = sd;
    }
    getEndDate(): number{
        return this.endDate;
    }
    setEndDate(ed: number): void{
        this.endDate = ed;
    }
    getInteractionID(): number{
        return this.interactionID;
    }
    setInteractionID(i: number): void{
        this.interactionID = i;
    }
}

export class PlayerProfile{
    playerProfileID: number;
    playerID:number;
    profileID: number;
    order: number;
    duration: number;
    lastModified: number;
    constructor(playerProfileID?: number,playerID?: number, profileID?: number, order?: number, duration?: number, lastModified?: number){
        this.playerProfileID = playerProfileID;
        this.playerID = playerID;
        this.profileID = profileID;
        this.order = order;
        this.duration = duration;
        this.lastModified = lastModified;
    }

    getPlayerProfileID(): number{
        return this.playerProfileID;
    }
    setPlayerProfileID(id: number): void{
        this.playerProfileID = id;
    }

    getPlayerID(): number{
        return this.playerID;
    }

    getProfileID(): number{
        return this.profileID;
    }

    getOrder(): number{
        return this.order;
    }

    getDuration(): number{
        return this.duration;
    }

    getLastModified(): number{
        return this.lastModified;
    }

    setOrder(order: number): void{
        this.order = order;
    }

    setDuration(duration: number): void{
        this.duration = duration;
    }

    
}

export class PlayerLocation{
    location_id: number;
    name: string;
    address: string;
    city: string;
    contact: string;
    county: string;
    country: string;
    email: string;
    phone: string;
    state: string;
    zip: string;
    timeZoneID: number;

    constructor(location_id?: number, name?: string, address?: string, city?: string, contact?: string, county?: string,
                country?: string, email?: string, phone?: string, state?: string, zip?: string, timeZoneID?: number){
        this.location_id = location_id;
        this.name = name;
        this.address = address;
        this.city = city;
        this.contact = contact;
        this.county = county;
        this.country = country;
        this.email = email;
        this.phone = phone;
        this.state = state;
        this.zip = zip;
        this.timeZoneID = timeZoneID;
    }
    getLocationID(): number{
        return this.location_id;
    }
    getName(): string{
        return this.name;
    }
    getAddress(): string{
        return this.address
    }
    getCity(): string{
        return this.city;
    }
    getContact(): string{
        return this.contact
    }
    getCounty(): string{
        return this.county;
    }
    getCountry(): string{
        return this.country;
    }
    getEmail(): string{
        return this.email
    }
    getPhone(): string{
        return this.phone;
    }
    getState(): string{
        return this.state;
    }
    getZip(): string{
        return this.zip; 
    }
    getTimeZoneID(): number{
        return this.timeZoneID
    }

    setName(l: string): void{
        this.name = l;
    }
    setAddress(l: string): void{
        this.address = l;
    }
    setCity(l: string): void{
        this.city = l;
    }
    setContact(l: string): void{
        this.contact = l;
    }
    setCounty(l: string): void{
        this.county = l;
    }
    setCountry(l: string): void{
        this.country = l;
    }
    setEmail(l: string): void{
        this.email = l;
    }
    setPhone(l: string): void{
        this.phone = l;
    }
    setState(l: string): void{
        this.state = l;
    }
    setZip(l: string): void{
        this.zip = l;
    }
    setTimeZoneID(l: number): void{
        this.timeZoneID = l;
    }

}

export class Player {
    playerID: number;
    name: string;
    description: string;
    lastModified: number;
    updatePending: number;
    playerProfiles: PlayerProfile[];
    playerContents: PlayerContent[];
    playerLocation: PlayerLocation;
    serialID: string;
    playerStatus: string;
    supportSuggestion: string;
    extendedSuggestion: string;
    lastUpdate: number;
    constructor(playerID?: number, name?: string, desc?: string, lastModified?: number, updatePending?: number, 
                playerProfiles?: JSON, serialID?: string, playerContents?: JSON, status?: string, supportSuggestion?: string,
                extendedSuggestion?: string, playerLocation?: JSON, lastUpdate?: number) {
        this.playerID = playerID;
        this.name = name;
        this.description = desc;
        this.lastModified = lastModified;
        this.updatePending = updatePending;
        this.playerProfiles = [];
        for(let i in playerProfiles){
            this.playerProfiles.push(new PlayerProfile(playerProfiles[i].playerProfileID, playerProfiles[i].playerID, playerProfiles[i].profileID, 
                                                       playerProfiles[i].order, playerProfiles[i].duration,
                                                       playerProfiles[i].lastModified));
        }
        this.playerContents = [];
        for(let i in playerContents){
            this.playerContents.push(new PlayerContent(playerContents[i].playerContentID, playerContents[i].contentID, playerContents[i].playerID, playerContents[i].lastModified, playerContents[i].isVerified,
                                                       playerContents[i].startDate, playerContents[i].endDate, playerContents[i].interactionID));
        }
        if(playerLocation){
            this.playerLocation = new PlayerLocation(playerLocation['location_id'], playerLocation['name'], playerLocation['address'], playerLocation['city'],
                                                     playerLocation['contact'], playerLocation['county'], playerLocation['country'], playerLocation['email'], playerLocation['phone'],
                                                     playerLocation['state'], playerLocation['zip'], playerLocation['timeZoneID']);
        }
        this.serialID = serialID;
        this.playerStatus = status;
        this.supportSuggestion = supportSuggestion;
        this.extendedSuggestion = extendedSuggestion;
        this.lastUpdate = lastUpdate;
        this.sortPlayerProfile();
        this.sortPlayerContents();
    }

    getPlayerID():number{
        return this.playerID;
    }

    getName(): string{
        return this.name;
    }
    setName(name: string): void{
        this.name = name;
    }

    getDescription(): string{
        return this.description;
    }
    setDescription(desc: string): void{
        this.description = desc;
    }

    getLastModified(): number{
        return this.lastModified;
    }
    setLastModified(lm: number): void{
        this.lastModified = lm;
    }

    getUpdatePending(): number{
        return this.updatePending;
    }
    setUpdatePending(updatePending: number): void{
        this.updatePending = updatePending;
    }

    getSerailID(): string{
        return this.serialID;
    }
    getPlayerProfiles(): PlayerProfile[]{
        return this.playerProfiles;
    }

    getPlayerProfile(profileID: number, order: number): PlayerProfile{
        var i = this.playerProfiles.findIndex(pp => pp.getProfileID() == profileID && pp.getOrder() == order);
        return this.playerProfiles[i];
    }
    addPlayerProfile(profileID: number, order: number, duration: number): void{
        //console.log(order);
        this.sortPlayerProfile();
        var i = order - 1;
        while(i>=0 && i < this.playerProfiles.length){
            this.playerProfiles[i].setOrder(i+2);
            i++;
        }
        let pf = new PlayerProfile(null, this.getPlayerID(), profileID, order, duration, this.getLastModified());
        this.playerProfiles.push(pf);
        this.sortPlayerProfile();
        //console.log(this.playerProfiles);
    }
    sortPlayerProfile(): void{
        this.playerProfiles.sort((pf1,pf2): number => {
            if(pf1.getOrder()>pf2.getOrder()){
                return 1; 
            } else{
                return -1;
            }
        });
    }
    reorderPlayerProfile(profileID: number, oldOrder: number, newOrder: number): void{
        let temp = this.getPlayerProfile(profileID, oldOrder);
        if(temp != null){
            let startIndex = (oldOrder > newOrder)? newOrder-1 : oldOrder;
            let endIndex = (oldOrder > newOrder)? oldOrder-1 : newOrder;
            let change = (oldOrder > newOrder)? 1 : -1;
            let i = startIndex;
            let pfList = this.getPlayerProfiles();
            while(i < endIndex){
              let pf = pfList[i];
              //console.log(i+1+change);
              pf.setOrder(i + 1 + change);
              i++;
            }
            temp.setOrder(newOrder);
            this.sortPlayerProfile();
        }
        
    }
    removePlayerProfile(profileID: number, order: number): void{
        var i = this.playerProfiles.findIndex(pp => pp.getProfileID() == profileID && pp.getOrder()==order);
        if(i > -1){
            let j = i+1;
            while(j< this.playerProfiles.length){
                this.playerProfiles[j].setOrder(j);
                j++;
            }
            this.playerProfiles.splice(i,1);
        }
        this.sortPlayerProfile();
    }

    getPlayerContents(): PlayerContent[]{
        return this.playerContents;
    }
    getPlayerContent(contentID: number): PlayerContent{
        var i = this.playerContents.findIndex(pc => pc.getContentID() == contentID);
        if(i>-1) return this.playerContents[i];
        return null;
    }
    removePlayerContent(contentID: number): void{
        var i = this.playerContents.findIndex(pc => pc.getContentID() == contentID);
        if(i>-1) {
            this.playerContents.splice(i,1);
        }
    }
    sortPlayerContents(): void{
        this.playerContents.sort((pc1,pc2): number => {
            if(pc1.isVerified > pc2.isVerified){
                return 1; 
            } else{
                return -1;
            }
        });
    }

    getPlayerLocation(): PlayerLocation{
        return this.playerLocation;
    }

    getPlayerStatus(): string{
        return this.playerStatus;
    }
    getSupportSuggestion(): string{
        return this.supportSuggestion;
    }
    getExtendedSuggestion(): string{
        return this.extendedSuggestion;
    }
    getLastUpdate(): number{
        return this.lastUpdate;
    }

    isPlayerUsable(): boolean{
        var loc = this.getPlayerLocation();
        if(loc.location_id == null) return false;
        if(loc.name == null || loc.name == '') return false;
        if(loc.address == null || loc.address == '') return false;
        if(loc.city == null || loc.city == '') return false;
        if(loc.contact == null || loc.contact == '') return false;
        if(loc.county == null || loc.county == '') return false;
        if(loc.country == null || loc.country == '') return false;
        if(loc.email == null || loc.email == '') return false;
        if(loc.phone == null || loc.phone == '') return false;
        if(loc.state == null || loc.state == '') return false;
        if(loc.zip == null || loc.zip == '') return false;
        if(loc.timeZoneID == null) return false;
        return true;
    }

    clone(): Player{
        var clone = new Player();
        clone.playerID = this.playerID;
        clone.name = this.name;
        clone.description = this.description;
        clone.lastModified = this.lastModified;
        clone.updatePending = this.updatePending;
        clone.playerProfiles = [];
        for(let i in this.playerProfiles){
            clone.playerProfiles.push(new PlayerProfile(this.playerProfiles[i].playerProfileID, this.playerProfiles[i].playerID, this.playerProfiles[i].profileID, 
                                                        this.playerProfiles[i].order, this.playerProfiles[i].duration,
                                                        this.playerProfiles[i].lastModified));
        }
        clone.playerContents = [];
        for(let i in this.playerContents){
            clone.playerContents.push(new PlayerContent(this.playerContents[i].playerContentID, this.playerContents[i].contentID, this.playerContents[i].playerID, this.playerContents[i].lastModified, 
                                                        this.playerContents[i].isVerified, this.playerContents[i].startDate, this.playerContents[i].endDate,
                                                        this.playerContents[i].interactionID));
        }
        if(this.playerLocation){
            clone.playerLocation = new PlayerLocation(this.playerLocation['location_id'], this.playerLocation['name'], this.playerLocation['address'], this.playerLocation['city'],
                                                      this.playerLocation['contact'], this.playerLocation['county'], this.playerLocation['country'], this.playerLocation['email'], this.playerLocation['phone'],
                                                      this.playerLocation['state'], this.playerLocation['zip'], this.playerLocation['timeZoneID']);
        }
        clone.serialID = this.serialID;
        clone.playerStatus = this.playerStatus;
        clone.supportSuggestion = this.supportSuggestion;
        clone.extendedSuggestion = this.extendedSuggestion;
        clone.lastUpdate = this.lastUpdate;
        return clone;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/player.ts